var zooomyBT= ($js)=>{
		var shop = "";
		var lang_s = "";
		var customer_email = "";
		var customer_name = "";
		var scripts = document.getElementsByTagName('script');
		for (var i = 0, l = scripts.length; i < l; i++) {
			if (scripts[i].getAttribute('data-shop') != null) {
				shop = scripts[i].getAttribute('data-shop');
			}
			if (scripts[i].getAttribute('data-customer') != null || scripts[i].getAttribute('data-customer') != "") {
				customer_email = scripts[i].getAttribute('data-customer');
			}
			if (scripts[i].getAttribute('data-customer-name') != null || scripts[i].getAttribute('data-customer-name') != "") {
				customer_name = scripts[i].getAttribute('data-customer-name');
			}
			if (scripts[i].getAttribute('data-handle') != null) {
				product_handle = scripts[i].getAttribute('data-handle');
			}
			if (scripts[i].getAttribute('data-product-id') != null) {
				bisproduct_id = scripts[i].getAttribute('data-product-id');
			}


		}
		shop = Shopify.shop;
		product_id = meta.product.id;
		if (product_id == "" || product_id == null || product_id == undefined) {
			product_id = bisproduct_id;
		}

		ZooomyStock(shop, product_handle, product_id, customer_email);

		function ZooomyStock(shop, product_handle, product_id, customer_email) {

			$js.ajax({
				url: "https://zooomyapps.com/backinstock/ZooomyBackinStockjson.php",
				data: {
					shop: shop,
					product_id: product_id
				},
				dataType: "jsonp",
				jsonp: "jsonCode",
				async: "true",
				success: function(jsonData) {
					var shop = jsonData.shop;
					var lang_s = "";
					var back_in_stock_text = jsonData.back_in_stock_text;
					var add_font_size = jsonData.add_font_size;
					var add_border_radius = jsonData.add_border_radius;
					var add_border_width = jsonData.add_border_width;
					var add_border_color = jsonData.add_border_color;
					var add_background_color = jsonData.add_background_color;
					var add_font_color = jsonData.add_font_color;
					var back_in_stock_width = jsonData.back_in_stock_width;
					var main_heading = jsonData.main_heading;
					var sub_heading = jsonData.sub_heading;
					var main_heading_color = jsonData.main_heading_color;
					var main_heading_size = jsonData.main_heading_size;
					var sub_heading_color = jsonData.sub_heading_color;
					var sub_heading_size = jsonData.sub_heading_size;
					var admin_email = jsonData.admin_email;
					var quantity = jsonData.quantity;
					var notify_msg = jsonData.notify_msg;
					var notify_emsg = jsonData.notify_emsg;
					var ccss = jsonData.ccss;
					var email_placeholder = jsonData.email_placeholder;
					var user_added_css = jsonData.user_added_css;
					var autoemail = jsonData.autoemail;
					var send_email = jsonData.checkdata;
					var shop_token = jsonData.shop_token;
					var branding = jsonData.branding;
					var tc_txt = jsonData.tc_txt;
					var lay = jsonData.lay;
					var znlsignup = jsonData.znlsignup;
					var znltxt = jsonData.znltxt;
					var maillist = jsonData.maillist;
					if (Shopify.locale != "") {
						lang_s = Shopify.locale;

					}
					var checktrue = "yes";
					var double_opt = jsonData.double_opt_enable;
					var znlcheck = "";
					var me = "";
					var protitle = "";
					var proprice = "";
					var proimg = "";
					var vnames = "";
					var vtitle = "";
					var variant_img = "";
					var vsku = "";
					var vid = "";
					if (customer_email == "null" || customer_email == null) {
						customer_email = "";
					}
					let product_handleIs=window.location.pathname
					$js("#zooomybackinstock").hide();
					$js.ajax({
						url: product_handleIs + '.js',
						dataType: 'json',
						success: function(cartvalues) {
							protitle = cartvalues.title;
							proprice = cartvalues.price;
							proimg = cartvalues.featured_image;


							$js('<style>share-button.share-button{clear:both;}.product-description.rte, .product-single__description.rte{clear:both;}#zooomybackinstock #zooomyalertemail, #zooomybackinstock #zooomyalertbtn{width:100%;max-width:100%;box-sizing:border-box; margin:5px 0px;text-align:center;}.zbackinstock__headings .zooomyh3{float:left;width:100%;text-align:center; font-size:' + main_heading_size + '; color:' + main_heading_color + ';}</style>').appendTo("body");
							$js('<style>.product-single__description.rte, .product__accordion.accordion { clear: both; }.zheading__text{float:left;width:100%;text-align:center; font-size:' + sub_heading_size + '; color:' + sub_heading_color + '}</style>').appendTo("body");
							$js('<style>#zooomyalertbtn{float:right; width:28%;padding:14px;background:' + add_background_color + '; color:' + add_font_color + ';font-size:' + add_font_size + ';border-radius:' + add_border_radius + ';border:' + add_border_width + ' solid ' + add_border_color + ';}</style>').appendTo("body");
							$js('<style>#zooomybackinstock form{float:left;width:100%;margin:0; padding:10px 0px;}#zooomybackinstock { margin:20px 0px;float: left; width: 100%; border: 1px solid #ededed; text-align:center; padding: 20px; box-sizing: border-box; }#zooomyalertemail {padding: 14px;box-sizing: border-box; float: left; width: 70%; }</style>').appendTo("head");
							$js('<style>#zooomyalertbtn{cursor:pointer;}</style>').appendTo("body");

							if ($js("#zooomybackinstock .zbackinstock__headings").length === 0) 
							{

							$js("#zooomybackinstock").append("<div class='zbackinstock__headings'><div class='zooomyh3'>" + main_heading + "</div><div class='zheading__text'>" + sub_heading + "</div></div>");
						    }

							if ($js("#zooomybackinstock #zooomybisform").length === 0) 
							{						    
							$js("#zooomybackinstock").append("<form method='' id='zooomybisform'><input type='email' name='zooomyalertemail' id='zooomyalertemail' placeholder='" + email_placeholder + "' value='" + customer_email + "'/><a class='zooomybtn zooomybutton' id='zooomyalertbtn'>" + back_in_stock_text + "</a></form>");
						    }
							if (znlsignup == "yes") {
							if ($js("#zooomybackinstock #zooomybisform .zooomyneslettersignup").length === 0) 
							{								
								$js("#zooomybackinstock form").append("<div class='zooomyneslettersignup'><div class='ZbisNewsSign'><input type='checkbox' id='zbisnl' /><label for='zbisnl'>" + znltxt + "</label><span class='clear'></span></div></div>");
								$js('<style>.ZbisNewsSign { float: left; width: 100%; text-align: center; }input#zbisnl { height: 14px; width: 17px; min-height: 0; }.ZbisNewsSign label { display: inline; padding-left: 5px; }.ZbisNewsSign { float: left; width: 100%; text-align: center; padding: 10px 0; }</style>').appendTo("body");
							}
						  }



							if (branding == "yes" && $js("#zooomybackinstock .zbranding").length === 0) {
								$js("#zooomybackinstock").append("<div class='zbranding' style='opacity:1!important;margin:2px 0;display:block!important;visibility:visible!important;font-weight:bold;font-size:14px!important;color:#333!important;float:left;width:100%;padding:5px 0;z-index:initial!important;margin:0!important;position:unset!important;display:block!important;'>Powered by <a style='color:#333;text-decoration:underline;display:inline!important;opacity:1!important;' href='https://apps.shopify.com/partners/zoomyapps' target='_blank'>Zooomy</a></div>");
								setTimeout(function() {
									if (document.querySelector('#zooomybackinstock > div.zbranding').innerHTML === "") {
										$js('.zbranding').replaceWith("<div style='opacity:1!important;margin:2px 0;visibility:visible!important;font-weight:bold;font-size:14px!important;color:#333!important;float:left;width:100%;padding:5px 0;z-index:initial!important;margin:0!important;position:unset!important;display:block!important;'>Powered by <a style='color:#333;text-decoration:underline;display:inline!important;opacity:1!important;' href='https://apps.shopify.com/partners/zoomyapps' target='_blank'>Zooomy</a></div>");
									}
								}, 2000);


							}

							if (tc_txt != "" && $js("#zooomybackinstock #zooomybistc").length === 0) {
								$js("#zooomybackinstock").append("<div style='font-size:12px;float:left;width:100%;padding:5px 0;' id='zooomybistc'>" + tc_txt + "</div>");
							}
							if (jsonData.double_opt_enable == "yes" && $js("#zooomybackinstock .zooomydoubleoptin").length === 0) {
								checktrue = "no";
								$js("<div class='zooomydoubleoptin'><input type='checkbox' id='zooomydoubleopt_Check'><label for='zooomydoubleopt_Check'>" + jsonData.double_opt_txt + "</label><span style='clear:both'></span></div>").insertAfter('#zooomyalertbtn');
								$js('<style>#zooomyalertbtn { opacity:0.6;pointer-events:none;}</style>').appendTo("body");
								$('#zooomydoubleopt_Check').change(function() {
									if ($('input#zooomydoubleopt_Check').prop('checked')) {
										checktrue = "yes";
										$js('<style>#zooomyalertbtn { opacity:1;pointer-events:all;}</style>').appendTo("body");
										double_opt = "yes";

									} else {
										checktrue = "no";
										$js('<style>#zooomyalertbtn { opacity:0.6;pointer-events:none;}</style>').appendTo("body");
										double_opt = "no";

									}
								});

							}

							$js('form[action="/cart/add"] select#ProductSelect-product-template').addClass("zooomybisalert");
							$js('form[action="/cart/add"] .Select.Select--primary select').addClass("zooomybisalert");
							$js('form[action="/cart/add"] select.no-js-required, form[action="/cart/add"] select.no-js').addClass("zooomybisalert");
							$js('form[action="/cart/add"] input[name="id"]').addClass("zooomybisalert");
							$js('form .variant-selection select[name="id"]').addClass("zooomybisalert");
							$js('form[action="/cart/add"] select[name="id"]').addClass("zooomybisalert");

							if ($js('.single-option-selector').length == 0) {
								$js('.option-selectors .selector-wrapper select').addClass("single-option-selector");
								$js('form .option-select-input').addClass("single-option-selector");
								$js('.select__select').addClass("single-option-selector");
								$js('select.product-variant-container').addClass("single-option-selector");

							}

							if (cartvalues.available == false) {

								$js("#zooomybackinstock").show();
							} else {
								$js("#zooomybackinstock").hide();
							}

							if (cartvalues.variants.length < 2) {
								if (cartvalues.available == false) {

									$js("#zooomybackinstock").show();
								} else {
									$js("#zooomybackinstock").hide();
								}
								vsku = cartvalues.variants[0].sku;
							} else {


								function getvariant(varid, allvariants) {
									for (i = 0; i < allvariants.length; i++) {
										if (allvariants[i].id == varid) {
											return allvariants[i]
										}
									}
								}
								var vars = [],
									hash;
								var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
								for (var i = 0; i < hashes.length; i++) {
									hash = hashes[i].split('=');
									vars.push(hash[0]);
									vars[hash[0]] = hash[1];
								}
								var checkdata = hash[1];


								function getUrlVars() {
									var vars = [],
										hash;
									var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
									for (var i = 0; i < hashes.length; i++) {
										hash = hashes[i].split('=');
										vars.push(hash[0]);
										vars[hash[0]] = hash[1];
									}
									return vars;
								}
								me = getUrlVars()["variant"];

								if (me == "undefined") {
									me = checkdata;
								}
								if (me == "") {
									me = checkdata;
								}

								if (me == "" || me == "undefined" || me == undefined) {
									if (('select.zooomybisalert').length) {
										me = $js(".zooomybisalert option:selected").val();

									}
									if (me == "" || me == "undefined" || me == undefined) {
										me = $js(".zooomybisalert").val();
									}
									if (me == "" || me == "undefined" || me == undefined) {

										me = $js('.zooomybisalert').find("option:first-child").val();

									}
								}
								if (me != undefined) {
									getvariantid = getvariant(me, cartvalues.variants);

									if (getvariantid) {
										if (getvariantid.available == false) {
											$js("#zooomybackinstock").show();

											vtitle = getvariantid.title;
											if (getvariantid.featured_image != null) {
												variant_img = getvariantid.featured_image.src;

											}
											if (vsku == "" || vsku == undefined || vsku == null) {
												vsku = getvariantid.sku;


											}

										}
										if (getvariantid.available == true) {

											$js("#zooomybackinstock").hide();

										}
									}



								}

				
                            $js(document).on('change', 'variant-selects .product-form__input input[type="radio"]', function () {
                             

									setTimeout(function() {
                                        let me = '';




		                         					

										if (me == "") {
											function getUrlVars() {
												var vars = [],
													hash;
												var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
												for (var i = 0; i < hashes.length; i++) {
													hash = hashes[i].split('=');
													vars.push(hash[0]);
													vars[hash[0]] = hash[1];
												}
												return vars;
											}
											me = getUrlVars()["variant"];
										}


										if (me == "undefined") {
											me = checkdata;
										}
										if (me == "") {
											me = checkdata;
										}
										if (me != undefined) {
											getvariantid = getvariant(me, cartvalues.variants);

											if (getvariantid) {

												if (getvariantid.available == false) {
													$js("#zooomybackinstock").show();
													if (vtitle == "" || vtitle == undefined || vtitle == null) {
														vtitle = getvariantid.title;

													}

													if (getvariantid.featured_image != null) {
														if (variant_img == "" || variant_img == undefined || variant_img == null) {
															variant_img = getvariantid.featured_image.src;
														}

													}


													vsku = getvariantid.sku;




												}
												if (getvariantid.available == true) {

													$js("#zooomybackinstock").hide();

												}
											}



										}
									}, 550);
								});

							}
							if (me == "") {
								me = vid;
							}


							$js('#zooomyalertbtn').click(function() {
								$js("p.zooomystockmsg").replaceWith("<p></p>");
								if (znlsignup == "yes") {
									if (document.getElementById('zbisnl').checked) {
										znlcheck = 'yes';
									}
								}

								var zooomyalertemail = $js("#zooomyalertemail").val();
								$js.ajax({
									url: "https://zooomyapps.com/backinstock/zooomybackinstock.php",
									data: {
										vsku: vsku,
										znlcheck: znlcheck,
										double_opt: double_opt,
										shop: shop,
										product_id: product_id,
										product_handle: product_handle,
										customer_name: customer_name,
										customer_email: customer_email,
										variant_id: me,
										title: protitle,
										img: proimg,
										price: proprice,
										vtitle: vtitle,
										zooomyalertemail: zooomyalertemail,
										variant_img: variant_img,
										lang_s: lang_s
									},
									dataType: "jsonp",
									jsonp: "ZooomyGetDataPage",
									async: "true",
									success: function(njsonData) {
										var already_added = " ";
										already_added = njsonData.already_added;
										
										$js('#zooomybackinstock input[type="email"]').val('');

									if ($js("#zooomybackinstock .zooomystockmsg").length === 0) {


										if (njsonData.emailcheck == "Valid") {
											$js("#zooomybackinstock").append("<p class='zooomystockmsg'>" + notify_msg + "</p>");

										}
										if (njsonData.emailcheck == "Invalid") {
											$js("#zooomybackinstock").append("<p  class='zooomystockmsg'>" + notify_emsg + "</p>");

										}

										if (already_added == "" || already_added == undefined) {} else {
											$js("#zooomybackinstock").append("<p  class='zooomystockmsg'>" + njsonData.already_added + "</p>");

										}
									}
									}
								});


								if (maillist == "yes") {
									var zooomyalertemail = $js("#zooomyalertemail").val();

									$js.ajax({
										url: "https://zooomyapps.com/backinstock/klaviyo/ZooomyFrontendAjax.php",
										data: {
											znlcheck: znlcheck,
											customer_email: zooomyalertemail,
											customer_name: customer_name,
											shop: shop,
											product_title: protitle
										},
										dataType: "jsonp",
										jsonp: "ZooomyGetMail",
										async: "true",
										success: function(mailJsonData) {

										}
									});
								}


							});
							document.addEventListener('keypress', (event) => {
								if (event.target.id === 'zooomyalertemail' && event.keyCode === 13) {
									const input = event.target;
									event.preventDefault();
									event.stopPropagation();
									const button = document.getElementById('zooomyalertbtn');
									if (button) {
										button.click();
									}
								}
							});


							if (autoemail == "yes" && send_email > 0) {
								var allv = [];

								for (i = 0; i < cartvalues.variants.length; i++) {
									if (cartvalues.variants[i].available == true) {
										valv = cartvalues.variants[i].id;
										allv.push(valv);
									}
								}

		                        if(jsonData.fae=="yes")
		                        {
								if (allv.length === 0) {

								} else {

									$js.ajax({
										url: "https://zooomyapps.com/backinstock/send-mail/zooomy_email_check.php",
										data: {
											shop: shop,
											product_id: product_id,
											product_handle: product_handle,
											variant_id: allv,
											title: protitle,
											img: proimg,
											shop_token: shop_token,
											lang_s: lang_s
										},
										dataType: "jsonp",
										jsonp: "ZooomyAutoEmail",
										async: "true",
										success: function(njsonData) {

										}
									});
								}
		                    }

							}
						}

					});

					$js('<style>#zooomybackinstock > div{display:block!important;}</style>').appendTo("body");
					$js('<style>' + ccss + '</style>').appendTo("body");
					$js('<style>' + user_added_css + '</style>').appendTo("body");

				}

			});

		}
}

  function reqJquery() {
    if ("undefined" == typeof jQuery || !jQuery || (1 === parseInt(jQuery.fn.jquery) && 11 > parseFloat(jQuery.fn.jquery.replace(/^1\./, "")))) {
        var o = document.getElementsByTagName("head")[0],
            t = document.createElement("script");
        (t.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js"),
            (t.type = "text/javascript"),
            (t.onload = t.onreadystatechange = function () {
                t.readyState ? ("complete" !== t.readyState && "loaded" !== t.readyState) || ((t.onreadystatechange = null), zooomyBT(jQuery.noConflict(!0))) : zooomyBT(jQuery.noConflict(!0));
            }),
            o.appendChild(t);
    } else zooomyBT(jQuery);
}
typeof meta !="undefined"  && "product" == meta.page.pageType ? setTimeout(reqJquery, 2e3) : reqJquery();